var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#17A2B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0679 22.5059C29.0281 19.0736 28.5398 14.3098 24.9259 11.3638C21.312 8.41777 15.6891 8.19987 11.7746 10.8541C7.85997 13.5084 6.86325 18.2147 9.44331 21.8617L8 26L13.2181 24.9389C16.0126 26.2355 19.251 26.2874 22 25.2713",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3662 18.8377H18.8377V16.3662L15.9543 13.4827C17.8446 12.58 20.0986 12.9667 21.5799 14.4479C23.0611 15.9292 23.4478 18.1832 22.545 20.0735L27.4881 25.0166C28.1706 25.6991 28.1706 26.8056 27.4881 27.4881C26.8056 28.1706 25.6991 28.1706 25.0166 27.4881L20.0735 22.545C18.1832 23.4478 15.9292 23.0611 14.4479 21.5799C12.9667 20.0986 12.58 17.8446 13.4827 15.9543L16.3662 18.8377",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequest);
export default __webpack_public_path__ + "static/media/service-request.aa0e7da5d09cef28df9731ffcb50695d.svg";
export { ForwardRef as ReactComponent };